import { Component, Inject, Input } from '@angular/core';
import { ApplicationFacade, RouteGroups } from '@ridango/components';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Env from '@ridango/core/env';
import { IonModalService } from '@ridango/core/lib/services/ion-modal.service';

@Component({
    selector: 'rwidget-explore-route-groups',
    templateUrl: 'explore-route-groups.component.html'
})
export class ExploreRouteGroupsComponent {
    @Input() routesGroups: RouteGroups[];

    public readonly assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(
        @Inject('ENV') public env: Env,
        private applicationFacade: ApplicationFacade,
        private ionModalService: IonModalService,
        private router: Router,
        private translate: TranslateService
    ) {}

    public async redirectToRoutes(routeGroup: RouteGroups): Promise<void> {
        this.ionModalService.scrollToTopTrigger();
        await this.router.navigate([this.translate.currentLang, 'explore', 'route-group', routeGroup.name]);
    }
}
